import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SimpleDialog from './SimpleDialog';
import FormDialog from './FormDialog';
import ViewDialog from './ViewDialog';
import InfoDialog from './InfoDialog';

import { Typography, TextField, Tooltip, IconButton} from '@material-ui/core';
import {
    ExpandMore, ChevronRight
} from '@material-ui/icons';
import { TreeView, TreeItem } from '@material-ui/lab';

import { NodeView } from './docx2/NodeView';
import { ContextMenu } from './docx2/ContextMenu';
import { MyToolbar } from './docx2/Toolbar';
import { SidePanel } from './docx2/SidePanel';

function filterClients(clients,filter) {

    const r = [];
    clients.forEach(item => {
        if (!item.name) {
            return;
        }
        const nameInUppercase = item.name.toUpperCase();
        if (!filter || !filter.trim() || nameInUppercase.startsWith(filter.toUpperCase())) {
            r.push(item);
        }
    });

    return r;
}

export class Docx2 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isAdmin: false, clients: [], filter:null, pos: null,
            node: null, nodeView: null, multipleNodeIds: null,expanded:[],
            tag: { meta: [], history: [], subscribe: [] }, isView: false,
            toCut: null,
            orderCriteria: 'Name'
        };

        this.dic = {};

        this.showAxiosError = this.showAxiosError.bind(this);

        this.onFilterChange = this.onFilterChange.bind(this);

        this.onContextMenu = this.onContextMenu.bind(this);
        this.onNodeSelect = this.onNodeSelect.bind(this);
        this.onNodeToggle = this.onNodeToggle.bind(this);
        this.rename = this.rename.bind(this);
        this.delete = this.delete.bind(this);

        this.upload = this.upload.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.fileInputChanged = this.fileInputChanged.bind(this);

        this.newClient = this.newClient.bind(this);
        this.create = this.create.bind(this);
        this.view = this.view.bind(this);
        this.download = this.download.bind(this);

        this.cut = this.cut.bind(this);
        this.paste = this.paste.bind(this);

        this.onOrderCriteriaChange = this.onOrderCriteriaChange.bind(this);
    }

    showAxiosError(error) {
        if (error.response && error.response.data) {
            this.infoDialog.show(error.response.data, "ERROR: " + error.response.status, true);
        } else {
            this.infoDialog.show(JSON.stringify(error), "ERROR", true);
        }
    }

    onFilterChange(value) {
        this.setState({ filter: value });
    }

    onOrderCriteriaChange(value) {
        this.setState({ orderCriteria: value });
    }

    onNodeSelect(event, value) {
        //alert(value.length);
        if (value && value.length === 1) {
            const id = value[0];
            axios.get('api/docx/tag/' + id)
                .then(response => {

                    const dic = this.dic;
                    //alert(id);
                    //alert(Object.keys(dic).length);
                    const nodeView = dic[id];
                    const node = nodeView.props.node;
                    this.setState({ tag: response.data, nodeView, node, isView: false, multipleNodeIds:null });
                })
        } else {
            this.setState({ tag: { meta: [], history: [], subscribe: [] }, node: null, nodeView: null, isView: false, multipleNodeIds: value });
        }
    }

    onNodeToggle(event, value) {
        this.setState({ expanded: value });
    }

    newClient() {
        //this.setState({ pos: null });
       
        this.formDialog.show("New Client", "", null, name => {
            axios.post("api/docx/newClient", { id: 'a29d4a3c-d732-4acc-8401-5cdfa2c32064', name }, { headers: { 'Content-Type': 'application/json' } })
                .then(response => {
                    this.loadClients();
                })
                .catch(this.showAxiosError);
        });
    }

    create() {
        //this.setState({ pos: null });
        const { node, nodeView } = this.state;
        const { name, id } = node;
        this.formDialog.show("New Folder", "Adding New Folder To " + name, null, fname => {
            axios.post("api/docx/create", { id, name: fname }, { headers: { 'Content-Type': 'application/json' } })
                .then(response => {
                    nodeView.loadChildren();
                })
                .catch(this.showAxiosError);
        });
    }

    view() {
        this.setState({ pos: null, isView: true });
    }

    download() {
        this.setState({ pos: null });
        const { node, nodeView, multipleNodeIds } = this.state;

        if (node) {
            const { name, id } = node;
            axios.get("api/docx/isFileExisted/" + id)
                .then(response => {
                    window.open('api/docx/download/' + id);
                })
                .catch(this.showAxiosError);
        } else if (multipleNodeIds && multipleNodeIds.length > 0) {
            multipleNodeIds.forEach(mid => {
                axios.get("api/docx/isFileExisted/" + mid)
                    .then(response => {
                        if (response.data) {
                            window.open('api/docx/download/' + mid);
                        }
                    })
                    .catch(this.showAxiosError);
            });
        }
    }

    upload() {
        //this.setState({ pos: null });
        this.fileInput.click();
    }
    uploadFile(files) {
        const { node, nodeView, expanded } = this.state;
        const { name, id } = node;

        let data = new FormData();
        for (var i = 0; i < files.length; i++) {
            data.append('files', files[i], files[i].name);
        }
        axios.post('api/docx/upload/' + id,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Accept-Language': 'en-US,en;q=0.8',
                    'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                }
            }
        ).then(response => {
            nodeView.loadChildren();
            expanded.push(node.id);
            this.setState({ expanded });
        })
        .catch(error => alert(error.message));
    }
    fileInputChanged() {
        this.uploadFile(this.fileInput.files);
    }

    rename() {
        //this.setState({ pos: null });
        const { node, nodeView } = this.state;
        const { name, id } = node;
        this.formDialog.show("Change Name", "Changing Name for " + name + "?", name, newName => {
            axios.post('api/docx/rename', { id: id, name: newName }, { headers: { 'Content-Type': 'application/json' } })
                .then(response => {
                    if (nodeView && nodeView.props.parent) {
                        nodeView.props.parent.loadChildren();
                    } else {
                        this.loadClients();
                    }
                    
                })
                .catch(this.showAxiosError);
        })
    }

    delete() {
        //this.setState({ pos: null });
        const { node, nodeView, multipleNodeIds } = this.state;
        if (node) {
            const { name, id } = node;
            this.simpleDialog.show("Are you sure to delete " + name + "?", r => {
                if (r) {
                    axios.delete('api/docx/delete/' + id)
                        .then(response => {
                            if (nodeView.props.parent) {
                                nodeView.props.parent.loadChildren();
                            } else {
                                this.loadClients();
                            }

                            this.setState({
                                node: null, nodeView: null, multipleNodeIds: null

                            });
                        })
                        .catch(error => alert(error.message));
                }
            });
        } else if (multipleNodeIds && multipleNodeIds.length > 0) {
            this.simpleDialog.show("Are you sure to delete the selected " + multipleNodeIds.length + " files? \nBe careful! \nMultipe files will be deleted!", r => {
                if (r) {
                    const dic = this.dic;
                    multipleNodeIds.forEach(mid => {
                        axios.delete('api/docx/delete/' + mid)
                            .then(response => {
                                const deletedNodeView = dic[mid];
                                if (deletedNodeView.props.parent) {
                                    deletedNodeView.props.parent.loadChildren();
                                } 
                            })
                            .catch(error => alert(error.message));
                    });

                    this.setState({
                        node: null, nodeView: null, multipleNodeIds: null

                    });
                }
            });
        }
        
    }

    copy() {
        
    }

    cut() {
        this.setState({ pos: null });
        const { node, nodeView, multipleNodeIds } = this.state;

        if (node) {
            const { name, id } = node;
            const toCut = [id];
            this.setState({ toCut });
        } else if (multipleNodeIds && multipleNodeIds.length > 0) {
            const toCut = [...multipleNodeIds];
            this.setState({
                toCut
            });
        }
    }

    paste() {
        this.setState({ pos: null });
        const { toCut, node, nodeView } = this.state;
        const { name, id } = node;
        const count = toCut.length;

        const filesParentNodeView = this.dic[toCut[0]].props.parent;

        this.simpleDialog.show("Are you sure to move " + count + ' files to ' + name + "?", r => {
            if (r) {
                axios.post('api/docx/paste', { fileIds: toCut, folderId: id, isCut: true })
                    .then(response => {
                        this.setState({ toCut: null });
                        filesParentNodeView.loadChildren();
                        nodeView.loadChildren();
                    })
                    .catch(error => alert(error.message));
            }
        });
    }

    onContextMenu(event,nodeId) {
        //event.preventDefault();
        const { node, multipleNodeIds } = this.state;
        if ((node && node.id === nodeId) || (multipleNodeIds && multipleNodeIds.includes(nodeId))) {
            this.setState({ anchorEL: event.currentTarget, pos: { top: event.pageY, left: event.pageX } });
        }
        event.stopPropagation();
        event.preventDefault();
    }

    loadIsAdmin() {
        axios.get('/api/docx/isAdmin')
            .then(response => {
                this.setState({ isAdmin: response.data });
            }).catch(this.showAxiosError);
    }
    loadClients() {
        axios.get('/api/docx/clients')
            .then(response => {
                this.setState({ clients: response.data });
            }).catch(this.showAxiosError);
    }

    render() {
        const { isAdmin, clients, filter, pos, node, multipleNodeIds, isView, tag, toCut, orderCriteria, expanded } = this.state;
        const dic = this.dic;

        return (
            <div>
                <MyToolbar onFilterChange={this.onFilterChange}
                    node={node} multipleNodeIds={multipleNodeIds} isAdmin={isAdmin}
                    onDelete={this.delete}
                    rename={this.rename}
                    upload={this.upload}
                    create={this.create}
                    newClient={this.newClient}
                    download={this.download}
                    view={this.view}
                    orderCriteria={orderCriteria}
                    onOrderCriteriaChange={this.onOrderCriteriaChange}
                />

                <input onChange={this.fileInputChanged} ref={ref => this.fileInput = ref} style={{ display: 'none' }} type='file' id='file' multiple />
                <br />

                <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1, overflowY: 'scroll', height: '80vh', overflowX: 'auto' }}>
                        <TreeView multiSelect
                            onNodeSelect={this.onNodeSelect}
                            onNodeToggle={this.onNodeToggle}
                            onContextMenu={event => {
                                event.stopPropagation();
                                event.preventDefault();
                            }}
                            expanded={expanded}
                            defaultCollapseIcon={<ExpandMore />} defaultExpandIcon={<ChevronRight />}>
                            {
                                (filterClients(clients, filter)).map(client => <NodeView onContextMenu={this.onContextMenu} node={client} dic={dic}
                                    orderCriteria={orderCriteria}
                                    ref={ref => dic[client.id] = ref}
                                    parent={null}
                                />)
                            }
                        </TreeView>
                    </div>
                    <div style={{ flex: 1 }}>
                        <SidePanel isAdmin={isAdmin}
                            isView={isView} node={node} tag={tag}
                            onUpload={this.uploadFile} />
                    </div>
                </div>
                <SimpleDialog ref={ref => this.simpleDialog = ref} />
                <FormDialog ref={ref => this.formDialog = ref} />
                <ViewDialog ref={ref => this.viewDialog = ref} />
                <InfoDialog ref={ref => this.infoDialog = ref} />
                <ContextMenu pos={pos} node={node} multipleNodeIds={multipleNodeIds} isAdmin={isAdmin}
                    onDelete={this.delete}
                    rename={this.rename}
                    upload={this.upload}
                    create={this.create}
                    newClient={this.newClient}
                    download={this.download}
                    cut={this.cut}
                    toCut={toCut}
                    paste={this.paste}
                    view={this.view}
                    onClose={() => this.setState({ pos: null })} />
            </div>
            );
    }

    componentDidMount() {
        this.loadIsAdmin();
        this.loadClients();
    }
}